import {Injectable} from "@angular/core";
import {SaveDeliveryPointUseCase} from "@app/core/delivery-point/application/save-delivery-point.use-case";
import {DeliveryPoint} from "@app/core/delivery-point/application/dtos/delivery-point";
import {Subject} from "rxjs";
import {take} from "rxjs/operators";
import {PopupNotifier} from "@app/presentation/components/errors/popup.notifier";
import {onError} from "@app/presentation/rxjs-utils/operators/on-error";
import {onIsLoadingChanges} from "@app/presentation/rxjs-utils/operators/on-is-loading-changes";
import {createStatusStore} from "@app/presentation/rxjs-utils/create-status-store";

@Injectable()
export class SelectDeliveryPointViewModel {

    notifier = new PopupNotifier()

    private deliveryPointHasBeenSavedSubject = new Subject<DeliveryPoint>();
    readonly deliveryPointHasBeenSaved$ = this.deliveryPointHasBeenSavedSubject.asObservable();

    private saveDeliveryPointStatus = createStatusStore();
    readonly isSaveDeliveryPointLoading$ = this.saveDeliveryPointStatus.isLoading$;

    constructor(
        private saveDeliveryPointUseCase: SaveDeliveryPointUseCase
    ) { }

    saveDeliveryPoint(deliveryPoint: DeliveryPoint) {
        this.saveDeliveryPointUseCase.execute({deliveryPoint, sendDeliveryPoint: true}).pipe(
            take(1),
            onIsLoadingChanges(this.saveDeliveryPointStatus.setIsLoading),
            onError(this.notifier.notifyError),
        ).subscribe({
            next: () => this.deliveryPointHasBeenSavedSubject.next(deliveryPoint),
        });
    }
}